import { SettingConst } from '@faire/web-api--source/types';

/**
 * Replaces ENABLE_BRAND_REVIEWS_HOLDOUT_XP_250222
 * Setting for a holdout in experiments in the reviews domain.
 * 10% of retailers will be in the treatment group which will not have access
 * to any review-related XP features in the coming 6 months.
 * Read more in the XP Plan:
 * https://www.notion.so/faire/XP-Plan-Reviews-Holdout-1912efb5c25a807ca6d5e1e19f5c6068
 */
export const ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306 =
  'ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306' as SettingConst<
    'ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
